import { map, deburr, lowerCase, filter } from "lodash";
import data from "../data/domains-data.json";

export const search = (formatedData: SearchResult[], searchedValue: string) =>
  filter(formatedData, (data) => {
    if (
      deburr(lowerCase(data.description)).includes(
        deburr(lowerCase(searchedValue))
      )
    ) {
      return data;
    } else {
      if (data && data.keywords && data?.keywords?.length > 0) {
        const isInKeywords = data.keywords.some((keyword) =>
          deburr(lowerCase(keyword)).includes(deburr(lowerCase(searchedValue)))
        );
        return isInKeywords && data;
      }
    }
  });

export const searchInAllData = (searchedValue: string, domain?: string) => {
  const formatedData: SearchResult[] = [];

  const domainData: Domain[] = domain
    ? filter(data, (data) => data.domain === domain)
    : data;

  map(domainData, (domain: Domain) => {
    map(domain.situations, (situation: Situation) => {
      if (situation.exemples) {
        map(situation.exemples, (exemple) => {
          formatedData.push({
            domain: domain.domain,
            url: exemple.title,
            title: situation.title,
            description: exemple.description,
            color: domain.color.default,
            orientation: exemple.orientation,
            preProcedure: exemple.preProcedure,
            contacts: exemple.contacts,
            keywords: map(exemple.keywords, (keywords) =>
              deburr(lowerCase(keywords))
            ),
          });
        });
      } else {
        formatedData.push({
          domain: domain.domain,
          url: situation.title,
          title: situation.title,
          description: situation.description,
          color: domain.color.default,
          orientation: situation.orientation,
          preProcedure: situation.preProcedure,
          contacts: situation.contacts,
          keywords: map(situation.keywords, (keywords) =>
            deburr(lowerCase(keywords))
          ),
        });
      }
    });
  });

  const searchResults = search(formatedData, searchedValue);

  return searchResults as SearchResult[];
};

export const searchInAlerteData = (searchedValue: string) => {
  const formatedData: any[] = [];

  const alertDomainData: Domain[] = filter(
    data,
    (data) => data.domain === "alerte"
  );

  map(alertDomainData, (domain: Domain) => {
    map(domain.situations, (situation: Situation) => {
      map(situation.thematique, (thematique: Thematique) => {
        map(thematique.themes, (theme) => {
          formatedData.push({
            domain: domain.domain,
            title: situation.title,
            url: situation.title,
            thematique: thematique.value,
            description: theme.value,
            color: "orange",
            theme: theme,
          });
        });
      });
    });
  });

  const searchResults = search(formatedData, searchedValue);

  return searchResults;
};
